import React from 'react';

import styles from './VolatilityMeasures.css';
import Card from '../../components/Card/Card';
import ErrorMessageNewFund from '../../components/ErrorMessages/ErrorMessageNewFund';
import { CARD_NAMES } from '../../utils/constants';
import GqlQueryWrapper from '../../components/GqlQueryWrapper/GqlQueryWrapper';
import Table from '../../components/Table/Table';
import TablePreRender from '../../components/Table/Table.prerender';
import TitleWithDescription from '../../components/TitleWithDescription/TitleWithDescription';
import {
    VOLATILITY_MEASURES,
    ETF_VOLATILITY_MEASURES,
    FI_ETF_VOLATILITY_MEASURES
} from './queries';
import { mkVolatilityMeasuresUtil, etfVolatilityMeasuresUtil } from './util';

const getQuery = (isFI, etf) => {
    if (isFI) {
        return FI_ETF_VOLATILITY_MEASURES;
    }

    return etf ? ETF_VOLATILITY_MEASURES : VOLATILITY_MEASURES;
};

const VolatilityMeasures = ({ etf, ticker, bond, moneyMarket, isFI }) => (
    <Card className="right">
        <GqlQueryWrapper
            query={getQuery(isFI, etf)}
            variables={{ ticker }}
            dataFunc={
                etf
                    ? etfVolatilityMeasuresUtil(isFI)
                    : mkVolatilityMeasuresUtil({
                          bond,
                          ticker,
                          moneyMarket
                      })
            }
            placeholder={() => <TablePreRender />}
        >
            {({
                data: { asOfDate, data, headers = [], primaryBenchmark = '' }
            }) =>
                asOfDate === 'N/A' ? (
                    <ErrorMessageNewFund
                        cardName={CARD_NAMES.VOLATILITY_AND_MEASURES}
                    />
                ) : (
                    <React.Fragment>
                        <div className="subsection-no-border">
                            <div className="container">
                                <TitleWithDescription
                                    title="Volatility and Other Measures"
                                    rightText={() => `As of ${asOfDate}`}
                                />
                                <Table
                                    customClassName="volatility"
                                    rowBars
                                    boldTableHeader={etf}
                                    hideTableHeaderBorder={etf}
                                    data={{ data, headers }}
                                />
                            </div>
                        </div>
                        {(moneyMarket || etf) && (
                            <div className="disclaimer">
                                Figures are calculated using monthly data and
                                are net of fees.
                            </div>
                        )}
                        <div className="glossary">
                            <a
                                className="glossary"
                                href="https://www.troweprice.com/personal-investing/funds/glossary.html"
                            >
                                See Glossary for details on all data elements
                            </a>
                        </div>
                        {etf && (
                            <div className="volatility-measures-footer-text">
                                * {primaryBenchmark.benchmarkName}
                            </div>
                        )}
                    </React.Fragment>
                )
            }
        </GqlQueryWrapper>
        <style jsx>{styles}</style>
    </Card>
);

export default VolatilityMeasures;
